import React, { useEffect, useState, useRef } from 'react';
import { Dialog, DialogContent, Button, Typography, Link, IconButton, Box, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Auth } from 'aws-amplify';
import { ReactComponent as GoogleG } from '../static/GoogleGDark.svg';

const POPUP_KEY = 'free_trial_popup_shown';
const SECOND_POPUP_KEY = 'free_trial_second_popup_shown';

export default function SubscriptionNudgePopUp() {
    const [open, setOpen] = useState(false);
    const [secondOpen, setSecondOpen] = useState(false);
    const secondTimerRef = useRef(null);

    useEffect(() => {
        if (window.sessionStorage.getItem(POPUP_KEY)) return;
        const timer = setTimeout(() => {
            setOpen(true);
            window.sessionStorage.setItem(POPUP_KEY, '1');
        }, 12000);
        return () => clearTimeout(timer);
    }, []);

    // Cleanup second timer on unmount
    useEffect(() => {
        return () => {
            if (secondTimerRef.current) clearTimeout(secondTimerRef.current);
        };
    }, []);

    const handleClose = () => {
        setOpen(false);
        // Only set up second nudge if it hasn't been shown yet
        if (!window.sessionStorage.getItem(SECOND_POPUP_KEY)) {
            secondTimerRef.current = setTimeout(() => {
                setSecondOpen(true);
                window.sessionStorage.setItem(SECOND_POPUP_KEY, '1');
            }, 45000); // 2 minutes
        }
    };

    const handleSecondClose = () => setSecondOpen(false);

    const renderDialog = (title, body) => (
        <Dialog
            open={true}
            onClose={title === 'Glad you\'re finding this useful!' ? handleSecondClose : handleClose}
            sx={{
                display: {
                    xs: 'block',
                    md: 'block',
                    lg: 'block',
                },
                '& .MuiDialog-container': {
                    '& .MuiPaper-root': {
                        width: '100%',
                        maxWidth: '720px',
                    },
                },
            }}
            scroll='paper'
        >
            <DialogContent sx={{
                boxShadow: 24,
                borderColor: 'var(--brand-main)',
                border: '1px solid var(--brand-main)',
                borderRadius: '16px',
                p: 4,
                position: 'relative',
                background: 'var(--revelata-paper-background-color, #fff)',
            }}>
                <Paper sx={{ p: 1, borderRadius: '12px', position: 'relative', background: 'transparent', boxShadow: 'none' }}>
                    <IconButton onClick={title === 'Glad you\'re finding this useful!' ? handleSecondClose : handleClose} size="small" aria-label="close" sx={{ position: 'absolute', top: 8, right: 8, display: {'xs': 'none', 'md': 'block' } }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h4" color="var(--brand-secondary)" sx={{ textAlign: 'center', mb: 1, fontSize: {'xs': '1.5rem', 'md': '2rem' } }}>
                        {title}
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: 'center', fontSize: {'xs': '0.85rem', 'md': '1.1rem' }, fontWeight: 300, mb: 2 }}>
                        {body}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                await Auth.signOut();
                                await Auth.federatedSignIn({ provider: 'Google' });
                            }}
                            sx={{
                                borderRadius: 3,
                                textTransform: 'none',
                                fontSize: {'xs': '0.7rem', 'md': '0.9rem' },
                                px: 2,
                                py: 1,
                                mt: 1
                            }}
                        >
                            <GoogleG style={{ height: '18px', marginRight: '8px', verticalAlign: 'middle' }} />
                            Sign In with Google for Full Access
                        </Button>
                        <Link href="/signup" sx={{ color: 'var(--brand-secondary)', textDecoration: 'underline', fontWeight: 400, fontSize: '0.95rem' }}>
                            Or create an account
                        </Link>
                        <Button
                            onClick={title === 'Glad you\'re finding this useful!' ? handleSecondClose : handleClose}
                            variant="text"
                            size="small"
                            sx={{
                                mt: 1,
                                color: 'text.secondary',
                                textTransform: 'none',
                                alignSelf: 'center',
                                minWidth: 180,
                                display: 'block',
                            }}
                        >Maybe later</Button>
                    </Box>
                </Paper>
            </DialogContent>
        </Dialog>
    );

    return (
        <>
            {open && renderDialog(
                'Useful insights?',
                <>
                    Access <b>10 years of data</b>, <br />
                    <b>earnings call transcripts</b>,<br />
                    <b>comps</b> that actually make sense,<br />
                    and our AI report writer and Excel Add-In<br />
                    for S&amp;P 500, 400, and 600 companies <br /><br />
                </>
            )}
            {secondOpen && renderDialog(
                "Glad you're finding this useful!",
                <>
                    Access <b>10 years of data</b>, <br />
                    <b>earnings call transcripts</b>,<br />
                    <b>comps</b> that actually make sense,<br />
                    and our AI report writer and Excel Add-In<br />
                    for S&amp;P 500, 400, and 600 companies <br /><br />
                </>
            )}
        </>
    );
} 